import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
  Button,
  Card,
  CardActions,
  CardContent,
  Container,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useMount, useUpdateEffect } from 'react-use';
import { setSignUpMode, signUp, signUpInit } from '../modules/signup';
import SignupTermsContainer from '../containers/signup/SignupTermsContainer';
import SignupContainer from '../containers/signup/SignupContainer';
import SignupCompleteContainer from '../containers/signup/SignupCompleteContainer';
import StepContainer from '../containers/signup/StepContainer';
import { signIn } from '../modules/manager';

const SignupPage = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const {
    signup: {
      mode,
      checked: { auth: checkedAuth, complete: checkedComplete },
      value,
    },
    manager: { isLoggedIn },
  } = useSelector((state) => state);
  const [enabled, setEnabled] = useState(false);

  const handleEnabled = (b) => {
    setEnabled(b);
  };

  const handleBefore = () => {
    if (mode) {
      dispatch(signUpInit());
      dispatch(setSignUpMode(mode - 1));
    } else {
      history.push('/');
    }
  };
  const handleNext = () => {
    if (enabled) {
      if (mode === 1) {
        dispatch(signUp());
      } else {
        dispatch(setSignUpMode(mode + 1));
      }
      handleEnabled(false);
    }
  };

  useEffect(() => {
    handleEnabled(checkedAuth || isLoggedIn);
    if (isLoggedIn) {
      dispatch(setSignUpMode(2));
    }
  }, [checkedAuth, isLoggedIn]);

  useUpdateEffect(() => {
    if (checkedComplete) {
      dispatch(signIn({ userId: value.userId, password: value.password }));
    }
    if (checkedAuth) {
      handleEnabled(true);
    }
  }, [checkedComplete]);

  useMount(() => mode === 0 && dispatch(signUpInit()));

  return (
    <Container maxWidth="lg" sx={{ margin: 'auto' }}>
      <StepContainer mode={mode} />
      <Card>
        <CardContent sx={{ minHeight: '540px' }}>
          {mode === 0 && <SignupTermsContainer setEnabled={handleEnabled} />}
          {mode === 1 && <SignupContainer />}
          {mode === 2 && <SignupCompleteContainer />}
        </CardContent>
        {mode < 2 && (
          <CardActions sx={{ padding: 4, justifyContent: 'space-between' }}>
            <Button
              color="secondary"
              variant="outlined"
              disabled={enabled}
              onClick={handleBefore}
            >
              이전
            </Button>
            <Button
              color="secondary"
              variant="contained"
              disabled={!enabled}
              onClick={handleNext}
            >
              다음
            </Button>
          </CardActions>
        )}
      </Card>
    </Container>
  );
};

export default SignupPage;
